import Badge from "@visa/vds/badge";
import React from "react";
import { SubscriptionStatus, SUBSCRIPTION_STATUS_BADGE_TYPES } from '_constants/SubscriptionConstants';

const SubscriptionStatusBadge = (props) => {
    if (props.status === SubscriptionStatus.Expired) {
        return <>{props.statusName}</>;
    }

    var statusName = props.statusName
    if (props.startDate && new Date(props.startDate) > new Date()) statusName += " (Future)"
    return <Badge id={props.id} type={SUBSCRIPTION_STATUS_BADGE_TYPES[props.status]}>
        {statusName}
    </Badge>;
};

export default SubscriptionStatusBadge;
